<template>
  <div class="printManagementDialog">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="800px">
      <div class="dialogContent">
        <el-form :model="form" ref="ruleForm" label-width="120px">
          <el-form-item label="姓名" prop="name" v-show="!emailMess">
            <el-input v-model="form.name" placeholder="请填写姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phoneNum"  v-show="!emailMess">
            <el-input
              v-model="form.phoneNum"
              placeholder="请填写手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件地址" prop="address"  v-show="!emailMess">
            <el-input v-model="form.address" placeholder="收件地址"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="emails" v-show="emailMess">
            <el-input v-model="form.emails" placeholder="电子邮箱"></el-input>
          </el-form-item>

          <el-form-item class="submitButtonClass">
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "materialManagementDialog",
  data() {
    return {
      dialogVisible: false,
      title: "",
      form: {
        name: "",
        address: "",
        phoneNum: "",
        emails: "",
      },
      emailMess: false,
    };
  },
  methods: {
    init(type, news) {
      this.dialogVisible = true;
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
      if (type === "add" && news === "address") {
        this.title = "新增收票地址";
        this.emailMess = false
      } else if (type === "edit" && news === "address") {
        this.title = "修改收票地址";
        this.emailMess = false
      } else if (type === "add" && news === "email") {
        this.title = "新增收票邮箱";
        this.emailMess = true
      } else if (type === "edit" && news === "email") {
        this.title = "新增收票邮箱";
        this.emailMess = true

      }
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.dialogContent {
  padding: 0 5%;
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
  }
  /deep/.el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 80px;
    height: 80px;
  }
  .thumbnailClass {
    width: 80px;
    height: 80px;
    margin-right: 20px;
    .avatar {
      width: 80px;
      height: 80px;
      border: 1px dashed #ddd;
      border-radius: 4px;
      line-height: 80px;
      font-size: 24px;
    }
  }
  .endPeriodClass {
    /deep/.el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .submitButtonClass {
    /deep/.el-form-item__content {
      margin-left: 0 !important;
      text-align: center;
      button {
        padding: 0;
        width: 120px;
        height: 35px;
        line-height: 35px;
        border-radius: 6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service/addressDialog.vue